export default function Sliders() {
  const init = () => {
    initInstagramSlider();
    initProductCategories();
    initRecipeCategoriesSlider();
    initRecipesSlider();
    initRelatedFamilySlider();
    initRelatedProductsSlider();
    initGallerySlider();
  }

  const initProductCategories = () => {
    const root = document.querySelector('.product-categories');
    const elmSlider = root?.querySelector('.js-product-categories');

    if (!elmSlider) return;

    const swiper = new Swiper(elmSlider, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: { enabled: true, momentum: true },
      navigation: {
        enabled: false,
        nextEl: '.product-categories .swiper-button-next',
        prevEl: '.product-categories .swiper-button-prev',
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
          freeMode: { enabled: false, momentum: false },
          navigation: { enabled: true },
        },
      }
    });
    // garante recalculo depois do layout estabilizar (fonts/imagens)
    requestAnimationFrame(() => {
      swiper.update();
    });
  }

  const initRecipesSlider = () => {

    const sliders = document.querySelectorAll('.js-recipes-slider');

    if(!sliders.length) return;

    sliders.forEach((elmSldier) => {
      if(elmSldier.swiper) return;
      new Swiper(elmSldier, {
        slidesPerView: 1.33,
        spaceBetween: 16,
        watchOverflow: true,
        freeMode: { enabled: true },
        breakpoints: {
          768: {
            slidesPerView: 4,
            freeMode: { enabled: false }
          }
        }
      });
    });
  }

  const initRecipeCategoriesSlider = () => {
    const elmSlider = document.querySelector('.js-recipe-categories-slider')
    if (elmSlider) {
      new Swiper(elmSlider, {
        slidesPerView: 2.65,
        spaceBetween: 16,
        freeMode: { enabled: true, momentum: true },
        navigation: {
          enabled: false,
          nextEl: '.recipe-categories .swiper-button-next',
          prevEl: '.recipe-categories .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            freeMode: { enabled: false },
            navigation: { enabled: true },
          },
          1024: {
            slidesPerView: 4,
            freeMode: { enabled: false },
            navigation: { enabled: true },
          },
          1200: {
            slidesPerView: 5,
            freeMode: { enabled: false },
            navigation: { enabled: true },
          },
        },
      })
    }
  }

  const initRelatedProductsSlider = () => {
    const elmSlider = document.querySelector('.js-related-products-slider')
    if (elmSlider) {
      new Swiper(elmSlider, {
        slidesPerView: 1.33,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 4,
          },
        },
      })
    }
  }

  const initRelatedFamilySlider = () => {
    const elmSlider = document.querySelector('.js-related-family')
    if (elmSlider) {
      new Swiper(elmSlider, {
        slidesPerView: 1.31,
        spaceBetween: 8,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
      })
    }
  }

  const initInstagramSlider = () => {
    const elmSlider = document.querySelector('.js-instagram-slider')
    if (elmSlider) {
      new Swiper(elmSlider, {
        slidesPerView: 1.33,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 4,
          },
        },
      })
    }
  }

  const initGallerySlider = () => {
    const elmGalleryFull = document.querySelector('.js-gallery-full-slider');
    const elmGalleryThumbs = document.querySelector('.js-gallery-thumbs-slider');

    if (!elmGalleryFull) return;

    elmGalleryFull?.swiper?.destroy(true, true);
    elmGalleryThumbs?.swiper?.destroy(true, true);

    const slideCount = elmGalleryFull.querySelectorAll('.swiper-slide').length;

    if (slideCount <= 1) {
      if (elmGalleryThumbs) elmGalleryThumbs.style.display = 'none';

      new Swiper(elmGalleryFull, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        preloadImages: false,
        lazy: { loadPrevNext: true, loadPrevNextAmount: 1 },
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        autoHeight: false,
        on: {
          imagesReady(swiper) { swiper.update(); },
        },
      });

      return;
    }

    const galleryThumbs = new Swiper(elmGalleryThumbs, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        768:{
          spaceBetween: 24,
        }
      }
    });

    const galleryFull = new Swiper(elmGalleryFull, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      watchSlidesProgress: true,
      allowTouchMove: true,
      thumbs: {
        swiper: galleryThumbs,
      },
      observer: true,
      observeParents: true,
      autoHeight: false,
      on: {
        imagesReady(swiper) { swiper.update(); },
      },
    });
  }

  init()
}
